module.exports = __webpack_public_path__ + "static/media/flag-sn.8ce841f9.webp";